export default __webpack_public_path__ + "static/media/remove.3a6f8c1b.svg";